import { render, staticRenderFns } from "./ClassifierSelect.vue?vue&type=template&id=0da5ae69&"
import script from "./ClassifierSelect.vue?vue&type=script&lang=ts&"
export * from "./ClassifierSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports